export default __webpack_public_path__ + "static/media/image-chair-algo-d-2-a-w@2x.097a8b89.webp";